import { Person } from '@/interfaces/person';
import { PersonResource, personResource } from '@/resources/person.resource';
import store from '../store';
import { EntityModule } from './entity.module';

/**
 * Moduł osób
 *
 * @export
 * @class PersonModule
 * @extends {EntityModule<Person, PersonResource>}
 */
export class PersonModule extends EntityModule<Person, PersonResource> {
  constructor() {
    super(personResource);

    this.actions = {
      ...this.actions,
      /**
       * Lista dla aktualnie zalogowanego użytkownika
       *
       * @returns {Promise<any>}
       */
      listForCurrentUser: (context: any, filters: any): Promise<any> => {
        const preventLoader = filters?.preventLoader;
        if (preventLoader) {
          filters = { ...filters, preventLoader: undefined };
        }
        const nodes: any[] = store.state.auth.nodes?.filter((node: any) => !!node.externalUid);
        if (nodes?.length) {
          return context.dispatch('list', { ...filters, structureUids: nodes.map(node => node.externalUid) });
        }

        const externalId = store.state.auth.data?.externalId;
        if (externalId) {
          return context.dispatch('list', { ...filters, userId: externalId });
        }

        context.commit('saveList', []);
        context.commit('saveCount', 0);
        return Promise.resolve(undefined);
      }
    };
  }
}

export default new PersonModule();
